import axios from "axios";
import { BASE_URL, SUB_URL_Checker } from "../BaseUrl";

const DispatchCheckerService = {

    get_userline_and_items: async (su_id) => {
    try {
      const formData = new URLSearchParams();
      formData.append('su_id', su_id);

      const response = await axios.post(
        'https://unit42.smartekanban.in/index.php/Apiv6/get_userline_and_itemsnew',
        formData,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error in get_userline_and_items:', error);
      throw error;
    }
  },
  
  get_eol_review_data: async (line_no, date) => {
    try {
      const formData = new URLSearchParams();
      formData.append('line_no', line_no);
      formData.append('date', date);

      const response = await axios.post(
        'https://unit42.smartekanban.in/index.php/Apiv6/get_eol_review_datas',
        formData,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error in get_eol_review_data:', error);
      throw error;
    }
  },
  update_eol_capa_report: async (capaData) => {
  try {
    const formData = new FormData();
    Object.keys(capaData).forEach(key => {
      formData.append(key, capaData[key]);
    });

    const response = await axios.post(
      'https://unit42.smartekanban.in/index.php/Apiv6/update_eol_capa_report',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error in update_eol_capa_report:', error);
    throw error;
  }
},
  store_eol_review: async (line_no, time_id, review_date, review_by, hour, added_by) => {
    try {
      const formData = new URLSearchParams();
      formData.append('line_no', line_no);
      formData.append('time_id', time_id);
      formData.append('review_date', review_date);
      formData.append('review_by', review_by);
      formData.append('hour', hour);
      formData.append('added_by', added_by);

      console.log('Request Body:', formData.toString()); // Log request body
      const response = await axios.post(
        'https://unit42.smartekanban.in/index.php/Apiv6/store_eol_review',
        formData,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
      console.log('Response Body:', response.data); // Log response body
      return response.data;
    } catch (error) {
      console.error('Error in store_eol_review:', error);
      throw error;
    }
  },
  get_eol_capa_by_filter: async (line_no, item_no, added_on) => {
    try {
      const formData = new FormData();
      formData.append('line_no', line_no);
      formData.append('item_no', item_no);
      formData.append('added_on', added_on);

      const response = await axios.post(
        'https://unit42.smartekanban.in/index.php/Apiv6/get_eol_capa_by_filter',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error in get_eol_capa_by_filter:', error);
      throw error;
    }
  },

  insert_eol_capa_report: async (capaData) => {
    try {
      const formData = new FormData();
      Object.keys(capaData).forEach(key => {
        formData.append(key, capaData[key]);
      });

      const response = await axios.post(
        'https://unit42.smartekanban.in/index.php/Apiv6/insert_eol_capa_report',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error in insert_eol_capa_report:', error);
      throw error;
    }
  },

  delete_eol_capa_report: async (ecr_id) => {
    try {
      const formData = new FormData();
      formData.append('ecr_id', ecr_id);

      const response = await axios.post(
        'https://unit42.smartekanban.in/index.php/Apiv6/delete_eol_capa_report',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error in delete_eol_capa_report:', error);
      throw error;
    }
  },
    store_eol_capa_reviews: async (reviewData) => {
    try {
      const formData = new FormData();
      Object.keys(reviewData).forEach(key => {
        formData.append(key, reviewData[key]);
      });

      const response = await axios.post(
        'https://unit42.smartekanban.in/index.php/Apiv6/store_eol_capa_reviews',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error in store_eol_capa_reviews:', error);
      throw error;
    }
  },
 getAllItemsForCapa: async (lineNo) => {
    try {
      const formData = new FormData();
      formData.append('line_no', lineNo);
      const response = await axios.post(
        'https://unit42.smartekanban.in/index.php/Apiv6/get_all_item_for_capa',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching items for CAPA:', error);
      throw error;
    }
  },

  getSiteTitle: async () => {
    try {
      const response = await axios.get('https://unit42.smartekanban.in/index.php/Apiv6/get_site_title');
      return response.data;
    } catch (error) {
      console.error('Error fetching site title:', error);
      throw error;
    }
  },

    getPartByItemId: async (part_id) => {
        console.log(part_id);
        
        try {
            const formData = new FormData();
            formData.append("part_id", part_id);

            const response = await axios.post(
                `https://unit42.smartekanban.in/index.php/Apiv6/get_parts_and_operation`,
                formData,
            );
            console.log(response.data);
            return response.data;

        } catch (error) {
            console.error(error);
        }
    },

    // `${BASE_URL.BASE_URL}${BASE_URL.API_URL}${SUB_URL_Checker.prepare_eol_screen}`,
    prepare_eol_screen: async (item_no) => {
        console.log("Item Number:", item_no);
    
        try {
            const formData = new FormData();
            formData.append("item_no", item_no);
    
            const response = await axios.post(
                "https://unit42.smartekanban.in/index.php/Apiv6/prepare_eol_screen",
                formData
            );
    
            console.log("API Response:", response.data);
            return response.data;

        } catch (error) {
            console.error("Error in prepare_eol_screen:", error);
            return null; 
        }
    },
    
 

      get_counts_v2: async (item_no, line_no) => {
        console.log("Item Number:", item_no);
        console.log("Line Number:", line_no);
        try {
            const formData = new FormData();
            formData.append("item_no", item_no);
            formData.append("line_no", line_no);
    
            const response = await axios.post(
                `https://unit42.smartekanban.in/index.php/Apiv6/fetch_kanban_status_v2`,
                formData
            );
            console.log("fetch_kanban_status", response.data);
            return response.data;
        } catch (error) {
            console.error(error);
        }
    },
    eol_pass: async (modalData, userId) => {
    try {
      const formData = new FormData();
      formData.append("item_no", modalData.item);
      formData.append("line_no", modalData.line);
      formData.append("checked_by", userId);
      formData.append("style_no", modalData.styleNo);
      formData.append("color", modalData.color); 

      const lineDigits = modalData.line.replace(/[^0-9]/g, '');
      const randomNumber = Math.floor(Date.now() /  1000);
      const pieceId = `${modalData.item}${lineDigits}${randomNumber}`;
      formData.append("piece_id", pieceId);

      const formDataObj = Object.fromEntries(formData.entries());
      console.log(formDataObj);

      const response = await axios.post(
        `https://unit42.smartekanban.in/index.php/Apiv6/eol_pass`,
        formData
      );
      console.log("fetch_kanban_status", response.data);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  eol_rejection: async (modalData, userId, prototypeForm) => {
    console.log("modalData Number:", modalData, prototypeForm);
    try {
      const formData = new FormData();
      formData.append("item_no", modalData.item);
      formData.append("line_no", modalData.line);
      formData.append("checked_by", userId);    
      formData.append("reason", prototypeForm?.getFieldValue("defect")); 
      formData.append("style_no", modalData.styleNo);
      formData.append("color", modalData.color);     
      formData.append("part_id", prototypeForm?.getFieldValue("part"));

      formData.append("nos", prototypeForm?.getFieldValue("quantity") || 1); 


      const lineDigits = modalData.line.replace(/[^0-9]/g, '');
      const randomNumber = Math.floor(Date.now() / 1000);
      const pieceId = `${modalData.item}${randomNumber}`;
      console.log(pieceId);

      formData.append("piece_id", pieceId);

      const formDataObj = Object.fromEntries(formData.entries());
      console.log(formDataObj);

      const response = await axios.post(
        `https://unit42.smartekanban.in/index.php/Apiv6/eol_rejection`,
        formData
      );
      console.log("fetch_kanban_status", response.data);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },


  
  eol_fail: async (modalData, userId, prototypeForm, imageType, defects) => {
    console.log("modalData Number:", modalData, prototypeForm, "defects:", defects);
    try {
      const formData = new FormData();
      formData.append("item_no", modalData.item);
      formData.append("line_no", modalData.line);
      formData.append("added_by", userId);
      formData.append("style_no", modalData.styleNo); 
      formData.append("color", modalData.color); 

      const lineDigits = modalData.line.replace(/[^0-9]/g, '');
      const randomNumber = Math.floor(Date.now() / 1000);
      const pieceId = `${modalData.item}${lineDigits}${randomNumber}`;
      formData.append("piece_id", pieceId);

      const defectsString = JSON.stringify(defects);
      formData.append("defects", defectsString);

      console.log("eol_fail payload:", Object.fromEntries(formData.entries()));

      const response = await axios.post(
        `https://unit42.smartekanban.in/index.php/Apiv6/eol_fail`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      console.log("eol_fail response:", response.data);
      return response.data;
    } catch (error) {
      console.error("eol_fail server error:", error.response?.data || error.message);
      throw error;
    }
  },


     // Updated API for fetching item details
  get_item_details: async (item_no) => {
    console.log("Item Number for Details:", item_no);

    // Validate item_no
    if (!item_no || typeof item_no !== 'string' || item_no.trim() === '') {
      console.warn("Invalid item_no, skipping API call:", item_no);
      return [];
    }

    try {
      const response = await axios.post(
        `https://unit42.smartekanban.in/index.php/Apiv6/get_item_details?item_no=${encodeURIComponent(item_no.trim())}`
      );

      console.log("get_item_details API Response:", response.data);

      if (response.data.status === false) {
        console.error("Backend Error:", response.data.message);
        return [];
      }

      return response.data.data || [];
    } catch (error) {
      console.error("Error in get_item_details:", error);
      return [];
    }
  },
      
      //Undo Button Api
      udo_eol_operations:()=>axios.post('https://unit42.smartekanban.in/index.php/Apiv6/udo_eol_operations')
};


export default DispatchCheckerService;
